import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { WritableDraft } from 'immer'
import { Service, ServiceDelivery } from '../../../types/interfaces'
import { ServiceAPI } from '../../../api/ServiceAPI'
import { AppState } from '../types'
import { getRegionCode } from '../utils/getRegionCode'
import { getSelectedLanguage } from '../utils/getSelectedLanguage'

export interface ServiceState {
  services: Service[]
  previousProgramId: string | null
  previousShiftId: string | null

  isLoading: boolean
  error: string | null
}

export const initialState: ServiceState = {
  services: [],
  previousProgramId: null,
  previousShiftId: null,
  isLoading: false,
  error: null,
}


export const fetchServices = createAsyncThunk<Service[], string>(
  'service/fetchServices',
  async (programId, { getState, rejectWithValue }) => {
    const regionCode = getRegionCode(getState() as AppState)
    const selectedLanguage = getSelectedLanguage(getState() as AppState)
    const serviceAPI = new ServiceAPI(regionCode, selectedLanguage)
    try {
      return await serviceAPI.getServices(programId)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)


const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setPreviousProgramId: (state, action: PayloadAction<string | null>) => {
      state.previousProgramId = action.payload
    },
    setPreviousShiftId: (state, action: PayloadAction<string | null>) => {
      state.previousShiftId = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state: WritableDraft<ServiceState>) => {
        state.isLoading = true
      })
      .addCase(fetchServices.fulfilled, (state: WritableDraft<ServiceState>, action: PayloadAction<any>) => {
        state.services = action.payload || []
        state.isLoading = false
      })
      .addCase(fetchServices.rejected, (state: WritableDraft<ServiceState>, action) => {
        state.error = (action.error.message as string) || null
        state.isLoading = false
      })
  },
})

export const { setPreviousProgramId, setPreviousShiftId } = serviceSlice.actions
export default serviceSlice.reducer
